import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BottomNavigationAction, Box, Tab, Tabs, useTheme } from '@mui/material';
import BottomNavigation from '@mui/material/BottomNavigation';
import useStyles from './Navigation.styles';
import useWindowDimensions, { MOBILE_SIZE } from '@hooks/useWindowDimensions';

const Navigation = (props) => {
  const { width } = useWindowDimensions();
  const isMobile = width <= MOBILE_SIZE;
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    const tempOpts = props.options;
    for (let i = 0; i < tempOpts.length; i++) {
      if (tempOpts[i].id === props.selectedItem) {
        if (selectedIndex !== i) {
          setSelectedIndex(i);
        }
        break;
      }
    }
  }, [props.selectedItem, props.options]);

  const handleChange = (idx) => {
    setSelectedIndex(() => idx);
    props.setIndex(() => idx);
    props.onChange(props.options[idx].id);
  };

  if (isMobile && props.bottomView) {
    return (
      <Box sx={props.customRootStyle ? props.customRootStyle : classes.root}>
        <BottomNavigation
          sx={classes.bottomTabs}
          showLabels
          value={selectedIndex}
          onChange={(event, newValue) => handleChange(newValue)}>
          {props.options.map((item, idx) => {
            return (
              <BottomNavigationAction key={item.id || idx} label={item.title} icon={item.icon} />
            );
          })}
        </BottomNavigation>
      </Box>
    );
  }

  return (
    <Box sx={props.customRootStyle ? props.customRootStyle : classes.root}>
      <Tabs
        sx={classes.tabs}
        value={selectedIndex}
        variant={isMobile && props.scrollable ? 'scrollable' : 'fullWidth'}
        scrollButtons={props.scrollable}
        allowScrollButtonsMobile={isMobile}
        indicatorColor='transparent'>
        {props.options.map((item, idx) => {
          return (
            <Tab
              key={item.id}
              iconPosition='start'
              label={item.title}
              icon={item.icon}
              onClick={() => handleChange(idx)}
            />
          );
        })}
      </Tabs>
    </Box>
  );
};

Navigation.proptypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      icon: PropTypes.node,
    }),
  ),
  selectedItem: PropTypes.string,
  setSelectedItem: PropTypes.func,
  onChange: PropTypes.func,
  index: PropTypes.number,
  setIndex: PropTypes.func,
  customRootStyle: PropTypes.object,
  bottomView: PropTypes.bool,
  scrollable: PropTypes.bool,
};

export default Navigation;
